import React, { useEffect, useState } from "react";
import { Form, Row, Col, Input, Card, Button } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getConfigs from "../../../GetConfigs";

const CaseAkaInformation = ({ ...props }) => {
	const { form, caseMaster } = props;

	useEffect(() => {
		const akaData = caseMaster?.aka?.LIST[0];
		form.setFieldsValue({ ...akaData });
	}, [caseMaster?.aka?.LIST, form]);

	const [messageVisible, setMessageVisible] = useState<boolean>(true)
	const configurations = getConfigs([
		"ctTRCRAKATxt",
	]);

	return (
		<div>
			<Row gutter={[16, 16]}>
				{configurations.ctTRCRAKATxt && messageVisible && (
					<Col xl={24} lg={24} md={24} sm={24} xs={24}>
						<Card>
							<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
								<FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
							</div>
							<br />
							<div dangerouslySetInnerHTML={{ __html: configurations.ctTRCRAKATxt }} />
						</Card>
					</Col>
				)}
				<Col xl={24} lg={24} md={24} sm={24} xs={24}>
					<BannerCard title="Information">
						<Form form={form} layout="vertical">
							<Form.Item name="AKA" label="Also Known As">
								<Input.TextArea readOnly />
							</Form.Item>
						</Form>
					</BannerCard>
				</Col>
			</Row>
		</div>
	);
};

export default CaseAkaInformation;
